import { loadSeasonScorers } from '../helpers/scorerSquads';
import { seasonScorerCollector } from '../helpers/simulatedScorers';
import SimulatedScorers from './SimulatedScorers';
import { readSimulationResponse, simulationErrorMessage } from "../helpers/simulationResponse";
import {
  forwardRef,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  Box,
  Button,
  CircularProgress,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  LinearProgress,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";

import {
  fetchFromApi,
} from "../helpers/fetchFromApi";

import {
  fetchViaPost,
} from "../helpers/fetchViaPost";

import {
  simOneGame,
} from "../helpers/directsimulation";

import {
  AppBar,
} from "../styled-components/AppBar";

import {
  LeagueDisplay,
} from "./LeagueDisplay";

import {
  LeagueTablePanel,
} from "./LeagueTablePanel";

import {
  TeamStrengthEditor,
} from "./TeamStrengthEditor";

const FAST_REFERENCE_CLASSES = [
  {
    favoriteProbability: 0.80,

    favoriteWin: [
      [1, 0, 8],
      [2, 0, 18],
      [2, 1, 12],
      [3, 0, 22],
      [3, 1, 16],
      [3, 2, 4],
      [4, 0, 9],
      [4, 1, 7],
      [4, 2, 2],
      [5, 0, 1],
      [5, 1, 1],
    ],

    draw: [
      [0, 0, 22],
      [1, 1, 48],
      [2, 2, 23],
      [3, 3, 6],
      [4, 4, 1],
    ],

    underdogWin: [
      [0, 1, 30],
      [0, 2, 13],
      [1, 2, 37],
      [0, 3, 4],
      [1, 3, 9],
      [2, 3, 7],
    ],
  },

  {
    favoriteProbability: 0.70,

    favoriteWin: [
      [1, 0, 16],
      [2, 0, 22],
      [2, 1, 22],
      [3, 0, 13],
      [3, 1, 16],
      [3, 2, 6],
      [4, 0, 2],
      [4, 1, 2],
      [4, 2, 1],
    ],

    draw: [
      [0, 0, 21],
      [1, 1, 49],
      [2, 2, 24],
      [3, 3, 5],
      [4, 4, 1],
    ],

    underdogWin: [
      [0, 1, 27],
      [0, 2, 12],
      [1, 2, 40],
      [0, 3, 3],
      [1, 3, 9],
      [2, 3, 9],
    ],
  },

  {
    favoriteProbability: 0.60,

    favoriteWin: [
      [1, 0, 24],
      [2, 0, 20],
      [2, 1, 28],
      [3, 0, 8],
      [3, 1, 12],
      [3, 2, 6],
      [4, 0, 1],
      [4, 1, 1],
    ],

    draw: [
      [0, 0, 20],
      [1, 1, 50],
      [2, 2, 24],
      [3, 3, 5],
      [4, 4, 1],
    ],

    underdogWin: [
      [0, 1, 24],
      [0, 2, 11],
      [1, 2, 42],
      [0, 3, 3],
      [1, 3, 9],
      [2, 3, 11],
    ],
  },

  {
    favoriteProbability: 0.50,

    favoriteWin: [
      [1, 0, 30],
      [2, 0, 17],
      [2, 1, 32],
      [3, 0, 5],
      [3, 1, 9],
      [3, 2, 6],
      [4, 1, 1],
    ],

    draw: [
      [0, 0, 19],
      [1, 1, 51],
      [2, 2, 24],
      [3, 3, 5],
      [4, 4, 1],
    ],

    underdogWin: [
      [0, 1, 22],
      [0, 2, 10],
      [1, 2, 43],
      [0, 3, 3],
      [1, 3, 9],
      [2, 3, 13],
    ],
  },

  {
    favoriteProbability: 0.40,

    favoriteWin: [
      [1, 0, 34],
      [2, 0, 14],
      [2, 1, 35],
      [3, 0, 4],
      [3, 1, 7],
      [3, 2, 5],
      [4, 1, 1],
    ],

    draw: [
      [0, 0, 18],
      [1, 1, 52],
      [2, 2, 24],
      [3, 3, 5],
      [4, 4, 1],
    ],

    underdogWin: [
      [0, 1, 20],
      [0, 2, 9],
      [1, 2, 44],
      [0, 3, 3],
      [1, 3, 9],
      [2, 3, 15],
    ],
  },
];


function pickWeightedFastScore(
  entries
) {
  const totalWeight =
    entries.reduce(
      (
        sum,
        entry
      ) =>
        sum +
        Number(
          entry[2] || 0
        ),
      0
    );

  let randomValue =
    Math.random() *
    totalWeight;

  for (
    const entry of
    entries
  ) {
    randomValue -=
      Number(
        entry[2] || 0
      );

    if (
      randomValue <= 0
    ) {
      return {
        favoriteGoals:
          Number(
            entry[0]
          ),

        underdogGoals:
          Number(
            entry[1]
          ),
      };
    }
  }

  const last =
    entries[
      entries.length - 1
    ];

  return {
    favoriteGoals:
      Number(
        last[0]
      ),

    underdogGoals:
      Number(
        last[1]
      ),
  };
}


function getFastReferenceClass(
  favoriteProbability
) {
  return FAST_REFERENCE_CLASSES
    .slice()
    .sort(
      (
        first,
        second
      ) =>
        Math.abs(
          first.favoriteProbability -
          favoriteProbability
        ) -
        Math.abs(
          second.favoriteProbability -
          favoriteProbability
        )
    )[0];
}


const Transition = forwardRef(
  function Transition(
    props,
    ref
  ) {
    return (
      <Slide
        direction="up"
        ref={ref}
        {...props}
      />
    );
  }
);


function cloneTable(rows) {
  return rows.map(
    (team) => ({
      ...team,

      overall: {
        ...(team.overall || {}),
      },

      home: {
        ...(team.home || {}),
      },

      away: {
        ...(team.away || {}),
      },
    })
  );
}


function addResult(
  values,
  goalsFor,
  goalsAgainst
) {
  values.games_played =
    Number(
      values.games_played || 0
    ) + 1;

  values.goals_scored =
    Number(
      values.goals_scored || 0
    ) + goalsFor;

  values.goals_against =
    Number(
      values.goals_against || 0
    ) + goalsAgainst;

  if (
    goalsFor >
    goalsAgainst
  ) {
    values.won =
      Number(
        values.won || 0
      ) + 1;

    values.points =
      Number(
        values.points || 0
      ) + 3;

    return;
  }

  if (
    goalsFor <
    goalsAgainst
  ) {
    values.lost =
      Number(
        values.lost || 0
      ) + 1;

    return;
  }

  values.draw =
    Number(
      values.draw || 0
    ) + 1;

  values.points =
    Number(
      values.points || 0
    ) + 1;
}


export function SimulationDialog({
  open,
  setOpen,
  leagues = [],
  user,
}) {
  const {
    t,
    i18n,
  } = useTranslation();

  const numberLocale =
    i18n.language?.startsWith("de")
      ? "de-DE"
      : "en-US";

  const [
    selectedLeague,
    setSelectedLeague,
  ] = useState(null);

  const [
    standings,
    setStandings,
  ] = useState([]);

  const [
    rows,
    setRows,
  ] = useState([]);

  const [
    fixtures,
    setFixtures,
  ] = useState([]);

  const [
    openFixtures,
    setOpenFixtures,
  ] = useState([]);

  const [
    simulationMatrices,
    setSimulationMatrices,
  ] = useState([]);

  const [
    matricesLoading,
    setMatricesLoading,
  ] = useState(false);

  const [
    matricesError,
    setMatricesError,
  ] = useState("");

  const [
    matrixProgress,
    setMatrixProgress,
  ] = useState({
    current: 0,
    total: 0,
  });

  const [
    simulating,
    setSimulating,
  ] = useState(false);

  const [
    simulationProgress,
    setSimulationProgress,
  ] = useState({
    current: 0,
    total: 0,
  });

  const [
    simulationMethod,
    setSimulationMethod,
  ] = useState("distribution");

  const [
    simulationMode,
    setSimulationMode,
  ] = useState("multiple");

  const [
    simulationRuns,
    setSimulationRuns,
  ] = useState(1000);

  const [scorerResults,setScorerResults] = useState(null);
  const [
    simulationResults,
    setSimulationResults,
  ] = useState([]);

  const [
    simulationResultMode,
    setSimulationResultMode,
  ] = useState("odds");

  const [
    simulationAnalysis,
    setSimulationAnalysis,
  ] = useState("champion");

  const [
    methodSelectionOpen,
    setMethodSelectionOpen,
  ] = useState(false);

  const [
    teamSettings,
    setTeamSettings,
  ] = useState([]);

  const [
    teamSettingsDialogOpen,
    setTeamSettingsDialogOpen,
  ] = useState(false);


  /*
   * Team Settings für den aktuell vorbereiteten
   * Simulationslauf.
   *
   * Diese Kopie darf verändert werden, ohne die
   * gespeicherten Team Settings anzutasten.
   */
  const [
    simulationTeamSettings,
    setSimulationTeamSettings,
  ] = useState([]);

  const [
    teamSettingsChanged,
    setTeamSettingsChanged,
  ] = useState(false);

  const [
    teamSettingsSaving,
    setTeamSettingsSaving,
  ] = useState(false);

  const [
    currentSeasonId,
    setCurrentSeasonId,
  ] = useState(null);

  /*
   * Bereits gespeicherter Season Base Record.
   *
   * Daraus lesen wir ausschließlich die für
   * diese konkrete Season hinterlegten
   * Standing Rules.
   *
   * Keine Competition-Regel wird im
   * SimulationDialog erfunden.
   */
  const [
    seasonBaseRecord,
    setSeasonBaseRecord,
  ] = useState(null);

  const [
    seasonParamsReloadKey,
    setSeasonParamsReloadKey,
  ] = useState(0);

  const teamSettingsApiRef =
    useRef(null);

  const simulationResultsRef =
    useRef(null);


  function handleClose() {
    setSelectedLeague(null);
    setOpen(false);
  }


  function handleLeagueSelect(
    event
  ) {
    const leagueId =
      Number(
        event.target.value
      );

    const nextLeague =
      leagues.find(
        (item) =>
          Number(
            item.id
          ) === leagueId
      ) || null;

    setSelectedLeague(
      nextLeague
    );
  }


  function getTeamGoalAverage(
    team
  ) {
    const forTotal =
      Number(
        team?.for_total
      );

    const againstTotal =
      Number(
        team?.against_total
      );

    if (
      !Number.isFinite(
        forTotal
      ) ||
      !Number.isFinite(
        againstTotal
      )
    ) {
      return null;
    }

    return (
      forTotal +
      againstTotal
    );
  }


  function getTeamHomeAdvantage(
    team
  ) {
    const forHome =
      Number(
        team?.for_homefactor
      );

    const againstHome =
      Number(
        team?.against_homefactor
      );

    if (
      !Number.isFinite(
        forHome
      ) ||
      !Number.isFinite(
        againstHome
      )
    ) {
      return null;
    }

    /*
     * Gemeinsame kompakte Kennzahl:
     *
     * 1 + (
     *   For Home Factor
     *   - Against Home Factor
     * ) / 2
     */
    return (
      1 +
      (
        forHome -
        againstHome
      ) /
      2
    );
  }


  function formatTeamSetting(
    value
  ) {
    const number =
      Number(
        value
      );

    if (
      !Number.isFinite(
        number
      )
    ) {
      return "–";
    }

    return number.toLocaleString(
      numberLocale,
      {
        minimumFractionDigits:
          3,

        maximumFractionDigits:
          3,
      }
    );
  }


  function renderTeamSettingsSummary() {
    const sortedSettings =
      simulationTeamSettings
        .slice()
        .sort(
          (
            first,
            second
          ) =>
            Number(
              second
                ?.total_strength ||
              0
            ) -
            Number(
              first
                ?.total_strength ||
              0
            )
        );

    return (
      <Paper
        variant="outlined"
        sx={{
          p:
            1.5,

          height:
            "100%",
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent=
            "space-between"
          sx={{
            mb:
              1,
          }}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight:
                  700,
              }}
            >
              {t(
                "help.simulationUI.startingPoint.teamSettingsTitle"
              )}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
            >
              {t(
                "help.simulationUI.startingPoint.teamSettingsDescription"
              )}
            </Typography>
          </Box>

          <Button
            size="small"
            variant="outlined"
            onClick={() =>
              setTeamSettingsDialogOpen(
                true
              )
            }
          >
            {t(
              "help.simulationUI.startingPoint.editTeamSettings"
            )}
          </Button>
        </Stack>


        <Box
          sx={{
            overflowX:
              "auto",

            maxHeight:
              650,

            overflowY:
              "auto",

            border:
              1,

            borderColor:
              "divider",

            borderRadius:
              1,
          }}
        >
          <Box
            sx={{
              minWidth:
                560,
            }}
          >
            <Box
              sx={{
                display:
                  "grid",

                gridTemplateColumns:
                  "36px minmax(150px, 1fr) 82px 82px 82px 82px",

                gap:
                  0.75,

                px:
                  1,

                py:
                  0.8,

                bgcolor:
                  "action.hover",

                borderBottom:
                  1,

                borderColor:
                  "divider",

                alignItems:
                  "center",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight:
                    700,
                }}
              >
                #
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  fontWeight:
                    700,
                }}
              >
                {t(
                  "help.simulationUI.columns.team"
                )}
              </Typography>

              <Typography
                variant="caption"
                align="center"
                sx={{
                  fontWeight:
                    700,
                }}
              >
                {t(
                  "help.simulationUI.startingPoint.strength"
                )}
              </Typography>

              <Typography
                variant="caption"
                align="center"
                sx={{
                  fontWeight:
                    700,
                }}
              >
                {t(
                  "help.simulationUI.startingPoint.goalAverage"
                )}
              </Typography>

              <Typography
                variant="caption"
                align="center"
                sx={{
                  fontWeight:
                    700,
                }}
              >
                {t(
                  "help.simulationUI.startingPoint.homeAdvantage"
                )}
              </Typography>

              <Typography
                variant="caption"
                align="center"
                sx={{
                  fontWeight:
                    700,
                }}
              >
                {t(
                  "help.simulationUI.startingPoint.drawFactor"
                )}
              </Typography>
            </Box>


            {sortedSettings.map(
              (
                setting,
                index
              ) => (
                <Box
                  key={
                    setting.id ||
                    setting.team_id
                  }
                  sx={{
                    display:
                      "grid",

                    gridTemplateColumns:
                      "36px minmax(150px, 1fr) 82px 82px 82px 82px",

                    gap:
                      0.75,

                    px:
                      1,

                    py:
                      0.65,

                    borderBottom:
                      1,

                    borderColor:
                      "divider",

                    alignItems:
                      "center",

                    "&:last-of-type": {
                      borderBottom:
                        0,
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    {
                      index +
                      1
                    }
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight:
                        600,

                      overflow:
                        "hidden",

                      textOverflow:
                        "ellipsis",

                      whiteSpace:
                        "nowrap",
                    }}
                  >
                    {setting.name ||
                      setting.team_name ||
                      setting.custom_name ||
                      `Team ${
                        setting.team_id ||
                        setting.id
                      }`}
                  </Typography>

                  <Typography
                    variant="body2"
                    align="center"
                    sx={{
                      fontWeight:
                        700,

                      fontVariantNumeric:
                        "tabular-nums",
                    }}
                  >
                    {formatTeamSetting(
                      setting.total_strength
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    align="center"
                    sx={{
                      fontVariantNumeric:
                        "tabular-nums",
                    }}
                  >
                    {formatTeamSetting(
                      getTeamGoalAverage(
                        setting
                      )
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    align="center"
                    sx={{
                      fontVariantNumeric:
                        "tabular-nums",
                    }}
                  >
                    {formatTeamSetting(
                      getTeamHomeAdvantage(
                        setting
                      )
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    align="center"
                    sx={{
                      fontVariantNumeric:
                        "tabular-nums",
                    }}
                  >
                    {formatTeamSetting(
                      setting.draw_factor
                    )}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      </Paper>
    );
  }


  function changeSimulationMethod(
    method
  ) {
    if (
      method ===
      simulationMethod
    ) {
      return;
    }

    setSimulationMethod(
      method
    );

    setSimulationMatrices([]);
    setSimulationResults([]);
    setScorerResults(null);

    /*
     * Nach einem Methodenwechsel wieder die reale,
     * aktuelle Tabelle anzeigen.
     */
    setRows(
      cloneTable(
        standings
      )
    );

    setMatrixProgress({
      current: 0,
      total:
        openFixtures.length,
    });

    setSimulationProgress({
      current: 0,
      total: 0,
    });

    setMatricesError("");
  }


  function buildCumulativeDistribution(
    distribution
  ) {
    let cumulativeProbability =
      0;

    const cumulativeDistribution =
      [];

    for (
      let homeGoals = 0;
      homeGoals <
      distribution.length;
      homeGoals++
    ) {
      const row =
        distribution[
          homeGoals
        ] ?? [];

      for (
        let awayGoals = 0;
        awayGoals <
        row.length;
        awayGoals++
      ) {
        const probability =
          Number(
            row[
              awayGoals
            ] ?? 0
          );

        cumulativeProbability +=
          probability;

        cumulativeDistribution.push(
          {
            homeGoals,
            awayGoals,
            probability,
            cumulativeProbability,
          }
        );
      }
    }

    return {
      cumulativeDistribution,
      totalProbability:
        cumulativeProbability,
    };
  }


  useEffect(() => {
    if (!selectedLeague) {
      return;
    }


    async function fetchTeams(
      seasonId
    ) {
      const response =
        await (
          await fetchFromApi(
            `fetch-data-v3/teams/seasons/${seasonId}`
          )
        ).json();

      return (
        response.data || []
      );
    }


    function getDetailValue(
      team,
      typeId
    ) {
      const value =
        team.details?.find(
          (detail) =>
            detail.type_id ===
            typeId
        )?.value;

      return Number(
        value ?? 0
      );
    }


    async function fetchSeasonTeams() {
      setRows([]);
      setStandings([]);
      setSimulationMatrices([]);
      setSimulationResults([]);
    setScorerResults(null);
      setTeamSettings([]);
      setSimulationTeamSettings([]);
      setTeamSettingsChanged(false);
      setCurrentSeasonId(null);
      setSeasonBaseRecord(null);
      setSimulationAnalysis("champion");
      setMatricesError("");

      setMatrixProgress({
        current: 0,
        total: 0,
      });

      setSimulationProgress({
        current: 0,
        total: 0,
      });

      const season =
        await (
          await fetchFromApi(
            "fetch-data-v3/leagues/" +
              selectedLeague.id +
              "?per_page=50&include=seasons"
          )
        ).json();

      const currentSeason =
        season?.data?.seasons?.find(
          (seasonItem) =>
            seasonItem.is_current ===
            true
        );

      if (!currentSeason) {
        return;
      }

      const currentSeasonId =
        currentSeason.id;

      setCurrentSeasonId(
        currentSeasonId
      );


      /*
       * Standing Rules dieser konkreten Season laden.
       *
       * Diese Daten liegen bereits in SEASON_BASE_STATS.
       */
      try {
        const seasonBaseResponse =
          await (
            await fetchViaPost(
              "get-season-base-stats",
              JSON.stringify({
                league_id:
                  selectedLeague.id,

                season_id:
                  currentSeasonId,

                fast_read:
                  true,
              })
            )
          ).json();

        if (
          seasonBaseResponse?.success &&
          seasonBaseResponse?.found &&
          seasonBaseResponse?.record
        ) {
          setSeasonBaseRecord(
            seasonBaseResponse.record
          );
        } else {
          setSeasonBaseRecord(
            null
          );
        }
      } catch (error) {
        console.error(
          "[Simulation] Season Base Stats",
          error
        );

        setSeasonBaseRecord(
          null
        );
      }


      /*
       * Team Settings laden.
       *
       * Diese Werte bilden die Ausgangsbasis
       * der Simulation und werden dem Benutzer
       * vor dem ersten Simulationslauf gezeigt.
       */

      try {
        const teamSettingsResponse =
          await (
            await fetchViaPost(
              "get-team-strengths-by-season-id",
              JSON.stringify({
                season_id:
                  currentSeasonId,
                league_id:
                  selectedLeague.id,
              })
            )
          ).json();

        const settingsMap =
          teamSettingsResponse
            ?.strengths ??
          teamSettingsResponse ??
          {};

        const loadedSettings =
          Object.values(
            settingsMap
          );

        setTeamSettings(
          loadedSettings
        );

        setSimulationTeamSettings(
          loadedSettings.map(
            (setting) => ({
              ...setting,
            })
          )
        );

        setTeamSettingsChanged(
          false
        );
      } catch (error) {
        console.error(
          "[Simulation] Team Settings",
          error
        );

        setTeamSettings([]);
        setSimulationTeamSettings([]);
      }


      const seasonWithFixtures =
        await (
          await fetchFromApi(
            `fetch-data-v3/seasons/${currentSeasonId}?include=fixtures.state;fixtures.participants`
          )
        ).json();

      const seasonFixtures =
        seasonWithFixtures
          ?.data
          ?.fixtures ?? [];

      const notPlayedFixtures =
        seasonFixtures.filter(
          (fixture) =>
            [
              "NS",
              "TBA",
              "POSTP",
            ].includes(
              fixture.state
                ?.state
            )
        );

      setFixtures(
        seasonFixtures
      );

      setOpenFixtures(
        notPlayedFixtures
      );


      /*
       * Zuerst die aktuelle Tabelle laden.
       * Dadurch kann sie bereits angezeigt
       * werden, während die Matrizen
       * vorbereitet werden.
       */

      const [
        teamData,
        responseStandings,
      ] = await Promise.all([
        fetchTeams(
          currentSeasonId
        ),

        fetchFromApi(
          `fetch-data-v3/standings/seasons/${currentSeasonId}?include=details;participant`
        ).then(
          (response) =>
            response.json()
        ),
      ]);


      const newRows = [];

      for (
        const team of
        responseStandings?.data ||
        []
      ) {
        const participant =
          team.participant ||
          teamData.find(
            (teamTwo) =>
              teamTwo.id ===
              team.participant_id
          );


        const overall = {
          games_played:
            getDetailValue(
              team,
              129
            ),

          won:
            getDetailValue(
              team,
              130
            ),

          draw:
            getDetailValue(
              team,
              131
            ),

          lost:
            getDetailValue(
              team,
              132
            ),

          goals_scored:
            getDetailValue(
              team,
              133
            ),

          goals_against:
            getDetailValue(
              team,
              134
            ),

          points:
            getDetailValue(
              team,
              187
            ),
        };


        const home = {
          games_played:
            getDetailValue(
              team,
              135
            ),

          won:
            getDetailValue(
              team,
              136
            ),

          draw:
            getDetailValue(
              team,
              137
            ),

          lost:
            getDetailValue(
              team,
              138
            ),

          goals_scored:
            getDetailValue(
              team,
              139
            ),

          goals_against:
            getDetailValue(
              team,
              140
            ),

          points:
            getDetailValue(
              team,
              185
            ),
        };


        const away = {
          games_played:
            getDetailValue(
              team,
              141
            ),

          won:
            getDetailValue(
              team,
              142
            ),

          draw:
            getDetailValue(
              team,
              143
            ),

          lost:
            getDetailValue(
              team,
              144
            ),

          goals_scored:
            getDetailValue(
              team,
              145
            ),

          goals_against:
            getDetailValue(
              team,
              146
            ),

          points:
            getDetailValue(
              team,
              186
            ),
        };


        newRows.push({
          id:
            team.id ??
            team.participant_id,

          participant_id:
            team.participant_id,

          team_id:
            team.participant_id,

          team_name:
            participant?.name ||
            team.participant
              ?.name ||
            String(
              team.participant_id
            ),

          logo_path:
            participant
              ?.image_path ||
            participant
              ?.logo_path ||
            "",

          overall,
          home,
          away,
        });
      }


      setStandings(
        newRows
      );

      setRows(
        newRows
      );


      /*
       * Die Ergebnismatrizen werden bewusst
       * noch NICHT vorbereitet.
       *
       * Das geschieht erst, wenn der Benutzer
       * Run simulation auswählt.
       */
      setMatricesLoading(false);
      setSimulationMatrices([]);

      setMatrixProgress({
        current: 0,
        total: notPlayedFixtures.length,
      });
    }


    fetchSeasonTeams().catch(error => {
      setMatricesError(simulationErrorMessage(error, t));
      setMatricesLoading(false);
    });

  }, [selectedLeague]);


  async function prepareSimulation() {
    if (
      !openFixtures.length
    ) {
      setSimulationMatrices([]);
      return [];
    }

    setMatricesLoading(true);
    setMatricesError("");

    setMatrixProgress({
      current: 0,
      total:
        openFixtures.length,
    });

    try {
      /*
       * ======================================================
       * SIMULATION BULK PREPARE
       * ======================================================
       *
       * Alle dafür notwendigen Fixture-Daten liegen im
       * SimulationDialog bereits vor.
       *
       * Deshalb nur EIN Request:
       *
       * - keine 40er-Slices mehr
       * - keine einzelne Fixture-Abfrage im Backend
       * - Team Settings dort nur einmal laden
       * - Season Parameters dort nur einmal laden
       */

      const simulationFixtures =
        openFixtures.map(
          (fixture) => {
            const homeParticipant =
              fixture
                ?.participants
                ?.find(
                  (participant) =>
                    participant
                      ?.meta
                      ?.location ===
                    "home"
                );

            const awayParticipant =
              fixture
                ?.participants
                ?.find(
                  (participant) =>
                    participant
                      ?.meta
                      ?.location ===
                    "away"
                );

            return {
              fixture_id:
                fixture.id,

              season_id:
                fixture.season_id,

              team_id_1:
                homeParticipant
                  ?.id,

              team_id_2:
                awayParticipant
                  ?.id,
            };
          }
        );


      const invalidFixture =
        simulationFixtures.find(
          (fixture) =>
            !Number.isFinite(
              Number(
                fixture.fixture_id
              )
            ) ||
            !Number.isFinite(
              Number(
                fixture.season_id
              )
            ) ||
            !Number.isFinite(
              Number(
                fixture.team_id_1
              )
            ) ||
            !Number.isFinite(
              Number(
                fixture.team_id_2
              )
            )
        );

      if (
        invalidFixture
      ) {
        throw new Error(
          "Simulation prepare: fixture data incomplete."
        );
      }


      const seasonId =
        Number(
          simulationFixtures[0]
            .season_id
        );


      const response = await readSimulationResponse(
          await fetchViaPost(
            "compile-fixtures-in-selection",

            JSON.stringify({
              /*
               * fixture_ids bleibt gesetzt,
               * damit die bestehende API-Signatur
               * kompatibel bleibt.
               *
               * Im neuen Bulk-Weg werden diese IDs
               * aber nicht einzeln nachgeladen.
               */
              fixture_ids:
                simulationFixtures.map(
                  (fixture) =>
                    fixture.fixture_id
                ),

              simulation_fixtures:
                simulationFixtures,

              simulation_season_id:
                seasonId,

              simulation_method:
                simulationMethod,

              /*
               * Die Simulation verwendet exakt die Werte,
               * die der User im Team-Settings-Schritt sieht.
               *
               * Sie werden NICHT gespeichert.
               */
              simulation_team_settings:
                simulationTeamSettings.map(
                  (setting) => {
                    const {
                      rank,
                      total_goals,
                      custom_name,
                      ...cleanSetting
                    } = setting;

                    return cleanSetting;
                  }
                ),

              persist_fixture_odds:
                false,
            })
          )
        );


      if (
        !response.success
      ) {
        if (
          response
            .needs_team_settings
        ) {
          throw new Error(
            t(
              "help.simulationUI.errors.missingTeamSettings"
            )
          );
        }

        throw new Error(
          response.error ||
          t(
            "help.simulationUI.errors.distributionCreation"
          )
        );
      }


      const collectedMatrices =
        [];


      for (
        const result of
        response.result ??
        []
      ) {
        const fixture =
          openFixtures.find(
            (item) =>
              Number(
                item.id
              ) ===
              Number(
                result.fixture_id
              )
          );


        const homeParticipant =
          fixture
            ?.participants
            ?.find(
              (participant) =>
                participant
                  ?.meta
                  ?.location ===
                "home"
            );


        const awayParticipant =
          fixture
            ?.participants
            ?.find(
              (participant) =>
                participant
                  ?.meta
                  ?.location ===
                "away"
            );


        const commonFixtureData = {
          fixture_id:
            result.fixture_id,

          home_team_id:
            homeParticipant
              ?.id,

          away_team_id:
            awayParticipant
              ?.id,

          home_team_name:
            homeParticipant
              ?.name,

          away_team_name:
            awayParticipant
              ?.name,
        };


        /*
         * ----------------------------------------------------
         * SCHNELLSIMULATION
         * ----------------------------------------------------
         */

        if (
          simulationMethod ===
          "fast"
        ) {
          const homeWin =
            Number(
              result.probs
                ?.homewin
            );

          const draw =
            Number(
              result.probs
                ?.draw
            );

          const awayWin =
            Number(
              result.probs
                ?.awaywin
            );


          if (
            !Number.isFinite(
              homeWin
            ) ||
            !Number.isFinite(
              draw
            ) ||
            !Number.isFinite(
              awayWin
            )
          ) {
            throw new Error(
              `Fast simulation probabilities missing for fixture ${result.fixture_id}.`
            );
          }


          collectedMatrices.push({
            ...commonFixtureData,

            simulation_method:
              "fast",

            probs: {
              homewin:
                homeWin,

              draw,

              awaywin:
                awayWin,
            },
          });

          continue;
        }


        /*
         * ----------------------------------------------------
         * DIREKTSIMULATION
         * ----------------------------------------------------
         */

        if (
          simulationMethod ===
          "direct"
        ) {
          const homeGoalExp =
            Number(
              result.homegoalexp
            );

          const awayGoalExp =
            Number(
              result.awaygoalexp
            );

          const drawFactor =
            Number(
              result.draw_factor
            );


          if (
            !Number.isFinite(
              homeGoalExp
            ) ||
            !Number.isFinite(
              awayGoalExp
            ) ||
            !Number.isFinite(
              drawFactor
            )
          ) {
            throw new Error(
              t(
                "help.simulationUI.errors.directParametersMissing",
                {
                  fixtureId:
                    result.fixture_id,
                }
              )
            );
          }


          collectedMatrices.push({
            ...commonFixtureData,

            simulation_method:
              "direct",

            homegoalexp:
              homeGoalExp,

            awaygoalexp:
              awayGoalExp,

            draw_factor:
              drawFactor,
          });

          continue;
        }


        /*
         * ----------------------------------------------------
         * VERTEILUNGSSIMULATION
         * ----------------------------------------------------
         */

        if (
          !Array.isArray(
            result.distribution
          )
        ) {
          throw new Error(
            t(
              "help.simulationUI.errors.fixtureDistributionMissing",
              {
                fixtureId:
                  result.fixture_id,
              }
            )
          );
        }


        const {
          cumulativeDistribution,
          totalProbability,
        } =
          buildCumulativeDistribution(
            result.distribution
          );


        collectedMatrices.push({
          ...commonFixtureData,

          simulation_method:
            "distribution",

          cumulativeDistribution,

          totalProbability,
        });
      }


      if (
        collectedMatrices.length !==
        openFixtures.length
      ) {
        throw new Error(
          `Simulation prepare incomplete: ${collectedMatrices.length} / ${openFixtures.length} fixtures.`
        );
      }


      /*
       * Der Bulk-Request ist abgeschlossen.
       * Deshalb springt der Fortschritt jetzt direkt auf 100 %.
       */
      setSimulationMatrices(
        collectedMatrices
      );

      setMatrixProgress({
        current:
          collectedMatrices.length,

        total:
          openFixtures.length,
      });


      return collectedMatrices;

    } catch (error) {
      setMatricesError(simulationErrorMessage(error, t));
      return null;
    } finally {
      setMatricesLoading(
        false
      );
    }
  }


  function simulateFixtureResult(
    simulationFixture
  ) {
    if (
      simulationFixture
        .simulation_method ===
      "fast"
    ) {
      const homeWin =
        Number(
          simulationFixture
            .probs
            ?.homewin || 0
        );

      const draw =
        Number(
          simulationFixture
            .probs
            ?.draw || 0
        );

      const awayWin =
        Number(
          simulationFixture
            .probs
            ?.awaywin || 0
        );

      const total =
        homeWin +
        draw +
        awayWin;

      if (
        total <= 0
      ) {
        throw new Error(
          "Fast simulation has no valid 1X2 probabilities."
        );
      }

      const normalizedHome =
        homeWin / total;

      const normalizedDraw =
        draw / total;

      const normalizedAway =
        awayWin / total;

      /*
       * Erste Zufallszahl:
       * ausschließlich der korrekte 1X2-Ausgang.
       */
      const resultRandom =
        Math.random();

      let actualOutcome;

      if (
        resultRandom <
        normalizedHome
      ) {
        actualOutcome =
          "home";
      } else if (
        resultRandom <
        normalizedHome +
          normalizedDraw
      ) {
        actualOutcome =
          "draw";
      } else {
        actualOutcome =
          "away";
      }


      const favoriteIsHome =
        normalizedHome >=
        normalizedAway;

      const favoriteProbability =
        Math.max(
          normalizedHome,
          normalizedAway
        );

      const referenceClass =
        getFastReferenceClass(
          favoriteProbability
        );


      let distribution;

      if (
        actualOutcome ===
        "draw"
      ) {
        distribution =
          referenceClass.draw;
      } else {
        const favoriteWon =
          (
            actualOutcome ===
              "home" &&
            favoriteIsHome
          ) ||
          (
            actualOutcome ===
              "away" &&
            !favoriteIsHome
          );

        distribution =
          favoriteWon
            ? referenceClass
                .favoriteWin
            : referenceClass
                .underdogWin;
      }


      /*
       * Zweite Zufallszahl:
       * nur noch das konkrete Torergebnis
       * innerhalb des bereits feststehenden
       * 1X2-Ausgangs.
       */
      const score =
        pickWeightedFastScore(
          distribution
        );


      if (
        actualOutcome ===
        "draw"
      ) {
        return {
          homeGoals:
            score.favoriteGoals,

          awayGoals:
            score.underdogGoals,
        };
      }


      if (
        favoriteIsHome
      ) {
        return {
          homeGoals:
            score.favoriteGoals,

          awayGoals:
            score.underdogGoals,
        };
      }

      return {
        homeGoals:
          score.underdogGoals,

        awayGoals:
          score.favoriteGoals,
      };
    }


    if (
      simulationFixture
        .simulation_method ===
      "direct"
    ) {
      const seed =
        Math.floor(
          Math.random() *
            2147483646
        ) + 1;

      const result =
        simOneGame(
          simulationFixture
            .homegoalexp,

          simulationFixture
            .awaygoalexp,

          simulationFixture
            .draw_factor,

          seed,

          false
        );

      return {
        homeGoals:
          Number(
            result.homeGoals ??
            result.home ??
            result.goalsHome ??
            result.goals_home ??
            0
          ),

        awayGoals:
          Number(
            result.awayGoals ??
            result.away ??
            result.goalsAway ??
            result.goals_away ??
            0
          ),
      };
    }


    const randomValue =
      Math.random();

    for (
      const entry of
      simulationFixture
        .cumulativeDistribution
    ) {
      if (
        randomValue <=
        entry
          .cumulativeProbability
      ) {
        return {
          homeGoals:
            entry.homeGoals,

          awayGoals:
            entry.awayGoals,
        };
      }
    }

    const last =
      simulationFixture
        .cumulativeDistribution[
        simulationFixture
          .cumulativeDistribution
          .length - 1
      ];

    return {
      homeGoals:
        last.homeGoals,

      awayGoals:
        last.awayGoals,
    };
  }


  function updateTable(
    table,
    homeTeamId,
    awayTeamId,
    homeGoals,
    awayGoals
  ) {
    const homeTeam =
      table.find(
        (team) =>
          Number(
            team.participant_id
          ) ===
          Number(
            homeTeamId
          )
      );

    const awayTeam =
      table.find(
        (team) =>
          Number(
            team.participant_id
          ) ===
          Number(
            awayTeamId
          )
      );

    if (
      !homeTeam ||
      !awayTeam
    ) {
      return;
    }


    /*
     * Gesamtwerte.
     */

    addResult(
      homeTeam.overall,
      homeGoals,
      awayGoals
    );

    addResult(
      awayTeam.overall,
      awayGoals,
      homeGoals
    );


    /*
     * Heim-/Auswärtswerte.
     *
     * Dadurch funktionieren in der
     * gemeinsamen LeagueTablePanel
     * auch Total / Home / Away nach
     * der Simulation korrekt.
     */

    addResult(
      homeTeam.home,
      homeGoals,
      awayGoals
    );

    addResult(
      awayTeam.away,
      awayGoals,
      homeGoals
    );
  }


  function rankTable(
    table
  ) {
    return table
      .slice()
      .sort(
        (
          teamOne,
          teamTwo
        ) => {
          const pointsOne =
            Number(
              teamOne.overall
                ?.points || 0
            );

          const pointsTwo =
            Number(
              teamTwo.overall
                ?.points || 0
            );

          if (
            pointsOne !==
            pointsTwo
          ) {
            return (
              pointsTwo -
              pointsOne
            );
          }

          const goalDifferenceOne =
            Number(
              teamOne.overall
                ?.goals_scored || 0
            ) -
            Number(
              teamOne.overall
                ?.goals_against || 0
            );

          const goalDifferenceTwo =
            Number(
              teamTwo.overall
                ?.goals_scored || 0
            ) -
            Number(
              teamTwo.overall
                ?.goals_against || 0
            );

          if (
            goalDifferenceOne !==
            goalDifferenceTwo
          ) {
            return (
              goalDifferenceTwo -
              goalDifferenceOne
            );
          }

          return (
            Number(
              teamTwo.overall
                ?.goals_scored || 0
            ) -
            Number(
              teamOne.overall
                ?.goals_scored || 0
            )
          );
        }
      )
      .map(
        (
          team,
          index
        ) => ({
          ...team,
          position:
            index + 1,
        })
      );
  }


  function simulateSeason(
    matrices, scorerRun
  ) {
    const simulatedTable =
      cloneTable(
        standings
      );

    for (
      const fixture of
      matrices
    ) {
      const result =
        simulateFixtureResult(
          fixture
        );

      scorerRun?.fixture(fixture,result);
      updateTable(
        simulatedTable,

        fixture
          .home_team_id,

        fixture
          .away_team_id,

        result.homeGoals,

        result.awayGoals
      );
    }

    scorerRun?.finish();
    return rankTable(
      simulatedTable
    );
  }


  async function runSimulation() {
    if (
      simulating ||
      matricesLoading
    ) {
      return;
    }

    /*
     * Wenn für die gewählte Methode noch keine
     * vorbereiteten Fixture-Daten vorliegen,
     * bereitet betty sie jetzt automatisch vor.
     *
     * Dafür ist keine zusätzliche Bestätigung
     * des Users notwendig.
     */
    if (
      openFixtures.length > 0 &&
      simulationMatrices.length !==
        openFixtures.length
    ) {
      const matrices =
        await prepareSimulation();

      if (!matrices) {
        return;
      }

      await executeSimulation(
        matrices
      );

      return;
    }

    await executeSimulation(
      simulationMatrices
    );
  }


  async function confirmTeamSettingsForSimulation() {
    /*
     * Die aktuell sichtbaren Team Settings werden
     * ausschließlich für diesen Simulationslauf verwendet.
     *
     * Bereits vorbereitete Simulationsdaten dürfen nicht
     * wiederverwendet werden, weil sie noch auf älteren
     * Team Settings beruhen könnten.
     */
    setTeamSettingsDialogOpen(
      false
    );

    setSimulationMatrices([]);
    setSimulationResults([]);
    setScorerResults(null);

    const matrices =
      await prepareSimulation();

    if (!matrices) {
      return;
    }

    await executeSimulation(
      matrices
    );
  }


  async function saveTeamSettingsAndContinue() {
    if (
      !simulationTeamSettings.length ||
      teamSettingsSaving
    ) {
      return;
    }

    setTeamSettingsSaving(
      true
    );

    try {
      const strengths =
        simulationTeamSettings.map(
          (setting) => {
            const {
              rank,
              total_goals,
              custom_name,
              ...cleanSetting
            } = setting;

            return cleanSetting;
          }
        );

      await fetchViaPost(
        "put-team-strengths",
        JSON.stringify(
          strengths
        )
      );

      /*
       * put-team-strengths berechnet die
       * gespeicherten Season Parameters neu.
       */
      setTeamSettings(
        simulationTeamSettings.map(
          (setting) => ({
            ...setting,
          })
        )
      );

      setTeamSettingsChanged(
        false
      );

      setSeasonParamsReloadKey(
        (value) =>
          value + 1
      );

      setTeamSettingsDialogOpen(
        false
      );

      /*
       * Nach dem Speichern mit exakt diesen Werten
       * neu vorbereiten und simulieren.
       *
       * Vorbereitete Daten aus einem früheren Lauf
       * dürfen nicht weiterverwendet werden.
       */
      setSimulationMatrices([]);
      setSimulationResults([]);
    setScorerResults(null);

      const matrices =
        await prepareSimulation();

      if (matrices) {
        await executeSimulation(
          matrices
        );
      }

    } catch (error) {
      console.error(
        "[Simulation] save Team Settings",
        error
      );

      setMatricesError(
        error?.message ||
        String(error)
      );

    } finally {
      setTeamSettingsSaving(
        false
      );
    }
  }


  async function executeSimulation(
    matrices
  ) {
    if (
      simulating ||
      matricesLoading
    ) {
      return;
    }

    setSimulating(true);
    setSimulationResults([]);
    setScorerResults(null);


    try {
      setScorerResults(null);
      const scorerTeams = await loadSeasonScorers(currentSeasonId,selectedLeague.id,standings);
      const scorers = seasonScorerCollector(scorerTeams,crypto.getRandomValues(new Uint32Array(1))[0]);

      /*
       * ------------------------------------------------------
       * MULTIPLE SIMULATIONS
       * ------------------------------------------------------
       */

      if (
        simulationMode ===
        "multiple"
      ) {
        const runs =
          Math.max(
            1,
            Math.min(
              100000,
              Number(
                simulationRuns
              ) || 1
            )
          );

        const placementCounts =
          new Map();

        for (
          const team of
          standings
        ) {
          placementCounts.set(
            team.participant_id,
            Array(
              standings.length
            ).fill(0)
          );
        }


        setSimulationProgress({
          current: 0,
          total: runs,
        });


        let lastTable = null;

        const YIELD_EVERY =
          25;


        for (
          let run = 0;
          run < runs;
          run++
        ) {
          const rankedTable =
            simulateSeason(
              matrices, scorers.startRun(run)
            );

          lastTable =
            rankedTable;


          rankedTable.forEach(
            (
              team,
              index
            ) => {
              const counts =
                placementCounts.get(
                  team.participant_id
                );

              if (counts) {
                counts[index] +=
                  1;
              }
            }
          );


          if (
            (
              run + 1
            ) %
              YIELD_EVERY ===
              0 ||
            run ===
              runs - 1
          ) {
            setSimulationProgress({
              current:
                run + 1,
              total:
                runs,
            });

            await new Promise(
              (resolve) =>
                setTimeout(
                  resolve,
                  0
                )
            );
          }
        }


        const aggregated =
          standings.map(
            (team) => {
              const counts =
                placementCounts.get(
                  team.participant_id
                ) ||
                Array(
                  standings.length
                ).fill(0);

              const weightedPositionSum =
                counts.reduce(
                  (
                    sum,
                    count,
                    index
                  ) =>
                    sum +
                    count *
                      (
                        index +
                        1
                      ),
                  0
                );

              return {
                team_id:
                  team.participant_id,

                team_name:
                  team.team_name,

                logo_path:
                  team.logo_path,

                counts,

                average_position:
                  runs > 0
                    ? weightedPositionSum /
                      runs
                    : 0,
              };
            }
          )
          .sort(
            (
              teamOne,
              teamTwo
            ) =>
              teamOne.average_position -
              teamTwo.average_position
          );


        setSimulationResults(
          aggregated
        );
        setScorerResults(scorers.summary());


        if (lastTable) {
          setRows(
            lastTable
          );
        }

        return;
      }


      /*
       * ------------------------------------------------------
       * SINGLE SIMULATION
       * ------------------------------------------------------
       */

      setSimulationProgress({
        current: 0,
        total:
          matrices.length,
      });


      const scorerRun = scorers.startRun(0);
      const simulatedTable =
        cloneTable(
          standings
        );

      const YIELD_EVERY =
        10;


      for (
        let index = 0;
        index <
        matrices.length;
        index++
      ) {
        const fixture =
          matrices[
            index
          ];

        const result =
          simulateFixtureResult(
            fixture
          );


        scorerRun.fixture(fixture,result);
        updateTable(
          simulatedTable,

          fixture
            .home_team_id,

          fixture
            .away_team_id,

          result.homeGoals,

          result.awayGoals
        );


        if (
          (
            index + 1
          ) %
            YIELD_EVERY ===
            0 ||
          index ===
            matrices.length -
              1
        ) {
          setSimulationProgress({
            current:
              index + 1,

            total:
              matrices.length,
          });


          await new Promise(
            (resolve) =>
              setTimeout(
                resolve,
                0
              )
          );
        }
      }


      scorerRun.finish();
      setScorerResults(scorers.summary());
      setRows(
        rankTable(
          simulatedTable
        )
      );

    } catch (error) {
      setMatricesError(simulationErrorMessage(error, t));
    } finally {
      setSimulating(
        false
      );
    }
  }


  function normalizeSeasonRuleCode(
    value
  ) {
    return String(
      value || ""
    )
      .trim()
      .toLowerCase()
      .replace(
        /_/g,
        "-"
      )
      .replace(
        /\s+/g,
        "-"
      );
  }


  function getSeasonRuleIdentity(
    rule
  ) {
    const providerCode =
      normalizeSeasonRuleCode(
        rule
          ?.provider_rule
          ?.type
          ?.code
      );

    if (providerCode) {
      return providerCode;
    }

    const developerName =
      normalizeSeasonRuleCode(
        rule
          ?.provider_rule
          ?.type
          ?.developer_name
      );

    if (developerName) {
      return developerName;
    }

    const category =
      normalizeSeasonRuleCode(
        rule?.rule_category
      );

    /*
     * "other" enthält bei SportMonks gerade
     * auch UEFA-Regeln.
     *
     * Ohne präziseren Provider-Code wäre
     * "other" deshalb keine brauchbare
     * Marktidentität.
     */
    if (
      category &&
      category !== "other"
    ) {
      return category;
    }

    const ruleText =
      normalizeSeasonRuleCode(
        rule?.rule_text
      );

    return ruleText || null;
  }


  function getSeasonTargetLabel(
    target
  ) {
    if (
      target?.marketType ===
      "top"
    ) {
      return `Top ${target.topPosition}`;
    }

    if (
      target?.marketType ===
      "promotion"
    ) {
      return i18n.language
        ?.startsWith("de")
        ? "Aufstieg"
        : "Promotion";
    }

    if (
      target?.marketType ===
      "relegation"
    ) {
      return i18n.language
        ?.startsWith("de")
        ? "Abstieg"
        : "Relegation";
    }

    if (
      target?.marketType ===
      "survival"
    ) {
      return i18n.language
        ?.startsWith("de")
        ? "Klassenerhalt"
        : "Survival";
    }


    const knownLabels = {
      "uefa-champions-league":
        "championsLeague",

      "uefa-champions-league-qualifiers":
        "championsLeagueQualifiers",

      "uefa-europa-league":
        "europaLeague",

      "uefa-europa-league-qualifiers":
        "europaLeagueQualifiers",

      "uefa-conference-league":
        "conferenceLeague",

      "uefa-conference-league-qualifiers":
        "conferenceLeagueQualifiers",

      "promotion":
        "promotion",

      "possible-promotion":
        "possiblePromotion",

      "promotion-play-off":
        "promotionPlayoff",

      "promotion-playoff":
        "promotionPlayoff",

      "relegation":
        "relegation",

      "possible-relegation":
        "possibleRelegation",

      "relegation-play-off":
        "relegationPlayoff",

      "relegation-playoff":
        "relegationPlayoff",
    };


    if (
      target.id ===
      "champion"
    ) {
      return t(
        "help.simulationUI.seasonMarkets.champion"
      );
    }


    const translationKey =
      knownLabels[
        target.ruleCode
      ];


    if (
      translationKey
    ) {
      return t(
        `help.simulationUI.seasonMarkets.${translationKey}`
      );
    }


    if (
      target.providerName
    ) {
      return target.providerName;
    }


    return String(
      target.ruleCode || ""
    )
      .split("-")
      .filter(Boolean)
      .map(
        (part) =>
          part.charAt(0)
            .toUpperCase() +
          part.slice(1)
      )
      .join(" ");
  }


  function isUefaSeasonRule(
    ruleCode
  ) {
    const code =
      normalizeSeasonRuleCode(
        ruleCode
      );

    return (
      code.includes(
        "uefa-champions-league"
      ) ||
      code.includes(
        "uefa-europa-league"
      ) ||
      code.includes(
        "uefa-conference-league"
      )
    );
  }


  function isPromotionSeasonRule(
    ruleCode
  ) {
    const code =
      normalizeSeasonRuleCode(
        ruleCode
      );

    return (
      code ===
        "promotion" ||
      code ===
        "possible-promotion" ||
      code ===
        "promotion-play-off" ||
      code ===
        "promotion-playoff"
    );
  }


  function isRelegationSeasonRule(
    ruleCode
  ) {
    const code =
      normalizeSeasonRuleCode(
        ruleCode
      );

    return (
      code ===
        "relegation" ||
      code ===
        "possible-relegation" ||
      code ===
        "relegation-play-off" ||
      code ===
        "relegation-playoff"
    );
  }


  function isPossibleSeasonRule(
    ruleCode
  ) {
    const code =
      normalizeSeasonRuleCode(
        ruleCode
      );

    return (
      code ===
        "possible-promotion" ||
      code ===
        "promotion-play-off" ||
      code ===
        "promotion-playoff" ||
      code ===
        "possible-relegation" ||
      code ===
        "relegation-play-off" ||
      code ===
        "relegation-playoff"
    );
  }


  function getSeasonTargets() {
    /*
     * ======================================================
     * SAISONMÄRKTE
     * ======================================================
     *
     * Entscheidend sind ausschließlich die Standing Rules
     * der KONKRETEN Season.
     *
     * Keine Liga bekommt hier fest verdrahtete Plätze.
     *
     * Beispiel:
     *
     * Wenn die Standing Rules einer Season ergeben:
     *
     *   CL: Plätze 1–4
     *   EL: Plätze 5–6
     *
     * dann werden daraus die wettüblichen kumulativen
     * Märkte:
     *
     *   Top 4 = Plätze 1–4
     *   Top 6 = Plätze 1–6
     *
     * Ändern sich die Berechtigungen in einer anderen
     * Liga oder Season, ändern sich die Top-N-Märkte
     * automatisch mit.
     *
     * Für Aufstieg / Abstieg gilt:
     *
     *   direkte Berechtigung = 1
     *   möglicher / Playoff-Fall = 1/3
     *
     * Die 1/3 entsprechen unserer Modellannahme:
     * Die höherklassige Mannschaft gewinnt den
     * Relegationsvergleich mit 2/3.
     */

    const result = [
      {
        id:
          "champion",

        ruleCode:
          "champion",

        positions:
          [1],

        weightedPositions: [
          {
            position:
              1,

            weight:
              1,
          },
        ],

        providerName:
          null,

        marketType:
          "champion",
      },
    ];


    const rules =
      Array.isArray(
        seasonBaseRecord
          ?.standing_rules
          ?.items
      )
        ? seasonBaseRecord
            .standing_rules
            .items
        : [];


    /*
     * Zunächst exakt die Regeln der Season gruppieren.
     *
     * Diese Rohgruppen bleiben unsere Wahrheit darüber,
     * welcher Platz wozu berechtigt.
     */
    const grouped =
      new Map();


    for (
      const rule of rules
    ) {
      const position =
        Number(
          rule?.position
        );


      if (
        !Number.isFinite(
          position
        ) ||
        position < 1
      ) {
        continue;
      }


      const ruleCode =
        getSeasonRuleIdentity(
          rule
        );


      if (
        !ruleCode
      ) {
        continue;
      }


      if (
        [
          "champion",
          "champions",
          "winner",
          "winners",
          "championship",
        ].includes(
          ruleCode
        )
      ) {
        continue;
      }


      const key =
        `rule:${ruleCode}`;


      if (
        !grouped.has(
          key
        )
      ) {
        grouped.set(
          key,
          {
            id:
              key,

            ruleCode,

            positions:
              [],

            providerName:
              rule
                ?.provider_rule
                ?.type
                ?.name ||
              null,
          }
        );
      }


      const target =
        grouped.get(
          key
        );


      if (
        !target.positions.includes(
          position
        )
      ) {
        target.positions.push(
          position
        );
      }
    }


    for (
      const target of
      grouped.values()
    ) {
      target.positions.sort(
        (
          first,
          second
        ) =>
          first -
          second
      );
    }


    /*
     * ------------------------------------------------------
     * EUROPÄISCHE BERECHTIGUNGEN -> TOP-N
     * ------------------------------------------------------
     *
     * Nicht "Europa League Plätze 5–6", sondern kumulativ
     * "Top 6".
     *
     * N wird ausschließlich aus den Standing Rules gelesen.
     */
    const topBoundaries =
      new Set();


    for (
      const target of
      grouped.values()
    ) {
      if (
        !isUefaSeasonRule(
          target.ruleCode
        )
      ) {
        continue;
      }


      const maximumPosition =
        Math.max(
          ...target.positions
        );


      if (
        Number.isFinite(
          maximumPosition
        )
      ) {
        topBoundaries.add(
          maximumPosition
        );
      }
    }


    Array.from(
      topBoundaries
    )
      .sort(
        (
          first,
          second
        ) =>
          first -
          second
      )
      .forEach(
        (
          topPosition
        ) => {
          /*
           * Platz 1 allein ist bereits "Meister".
           */
          if (
            topPosition <= 1
          ) {
            return;
          }


          const positions =
            Array.from(
              {
                length:
                  topPosition,
              },
              (
                _,
                index
              ) =>
                index + 1
            );


          result.push({
            id:
              `top-${topPosition}`,

            ruleCode:
              `top-${topPosition}`,

            positions,

            weightedPositions:
              positions.map(
                (
                  position
                ) => ({
                  position,

                  weight:
                    1,
                })
              ),

            providerName:
              null,

            marketType:
              "top",

            topPosition,
          });
        }
      );


    /*
     * ------------------------------------------------------
     * AUFSTIEG
     * ------------------------------------------------------
     */
    const promotionWeights =
      new Map();


    for (
      const target of
      grouped.values()
    ) {
      if (
        !isPromotionSeasonRule(
          target.ruleCode
        )
      ) {
        continue;
      }


      const weight =
        isPossibleSeasonRule(
          target.ruleCode
        )
          ? 1 / 3
          : 1;


      for (
        const position of
        target.positions
      ) {
        promotionWeights.set(
          position,
          Math.max(
            Number(
              promotionWeights.get(
                position
              ) || 0
            ),
            weight
          )
        );
      }
    }


    if (
      promotionWeights.size >
      0
    ) {
      const weightedPositions =
        Array.from(
          promotionWeights.entries()
        )
          .sort(
            (
              first,
              second
            ) =>
              first[0] -
              second[0]
          )
          .map(
            (
              [
                position,
                weight,
              ]
            ) => ({
              position,
              weight,
            })
          );


      result.push({
        id:
          "promotion-market",

        ruleCode:
          "promotion",

        positions:
          weightedPositions.map(
            (
              entry
            ) =>
              entry.position
          ),

        weightedPositions,

        providerName:
          null,

        marketType:
          "promotion",
      });
    }


    /*
     * ------------------------------------------------------
     * ABSTIEG + KLASSENERHALT
     * ------------------------------------------------------
     */
    const relegationWeights =
      new Map();


    for (
      const target of
      grouped.values()
    ) {
      if (
        !isRelegationSeasonRule(
          target.ruleCode
        )
      ) {
        continue;
      }


      const weight =
        isPossibleSeasonRule(
          target.ruleCode
        )
          ? 1 / 3
          : 1;


      for (
        const position of
        target.positions
      ) {
        relegationWeights.set(
          position,
          Math.max(
            Number(
              relegationWeights.get(
                position
              ) || 0
            ),
            weight
          )
        );
      }
    }


    if (
      relegationWeights.size >
      0
    ) {
      const weightedPositions =
        Array.from(
          relegationWeights.entries()
        )
          .sort(
            (
              first,
              second
            ) =>
              first[0] -
              second[0]
          )
          .map(
            (
              [
                position,
                weight,
              ]
            ) => ({
              position,
              weight,
            })
          );


      const positions =
        weightedPositions.map(
          (
            entry
          ) =>
            entry.position
        );


      result.push({
        id:
          "relegation-market",

        ruleCode:
          "relegation",

        positions,

        weightedPositions,

        providerName:
          null,

        marketType:
          "relegation",
      });


      result.push({
        id:
          "survival-market",

        ruleCode:
          "survival",

        positions,

        weightedPositions,

        providerName:
          null,

        marketType:
          "survival",

        complement:
          true,
      });
    }


    /*
     * ------------------------------------------------------
     * SONSTIGE PROVIDER-REGELN
     * ------------------------------------------------------
     *
     * Nichts wegwerfen, was wir noch nicht ausdrücklich
     * in einen Wettmarkt übersetzt haben.
     */
    for (
      const target of
      grouped.values()
    ) {
      if (
        isUefaSeasonRule(
          target.ruleCode
        ) ||
        isPromotionSeasonRule(
          target.ruleCode
        ) ||
        isRelegationSeasonRule(
          target.ruleCode
        )
      ) {
        continue;
      }


      result.push({
        ...target,

        weightedPositions:
          target.positions.map(
            (
              position
            ) => ({
              position,

              weight:
                1,
            })
          ),

        marketType:
          "provider",
      });
    }


    return result.sort(
      (
        first,
        second
      ) => {
        if (
          first.id ===
          "champion"
        ) {
          return -1;
        }


        if (
          second.id ===
          "champion"
        ) {
          return 1;
        }


        if (
          first.marketType ===
            "top" &&
          second.marketType !==
            "top"
        ) {
          return -1;
        }


        if (
          second.marketType ===
            "top" &&
          first.marketType !==
            "top"
        ) {
          return 1;
        }


        if (
          first.marketType ===
            "top" &&
          second.marketType ===
            "top"
        ) {
          return (
            first.topPosition -
            second.topPosition
          );
        }


        const order = {
          promotion:
            10,

          provider:
            20,

          relegation:
            30,

          survival:
            31,
        };


        const firstOrder =
          order[
            first.marketType
          ] ?? 20;

        const secondOrder =
          order[
            second.marketType
          ] ?? 20;


        if (
          firstOrder !==
          secondOrder
        ) {
          return (
            firstOrder -
            secondOrder
          );
        }


        return (
          Math.min(
            ...first.positions
          ) -
          Math.min(
            ...second.positions
          )
        );
      }
    );
  }


  function getSelectedSeasonTarget() {
    const targets =
      getSeasonTargets();


    return (
      targets.find(
        (
          target
        ) =>
          target.id ===
          simulationAnalysis
      ) ||
      targets[0] ||
      null
    );
  }


  function getSeasonTargetCount(
    result,
    target
  ) {
    if (
      !target ||
      !Array.isArray(
        result?.counts
      )
    ) {
      return 0;
    }


    const weightedPositions =
      Array.isArray(
        target.weightedPositions
      )
        ? target.weightedPositions
        : (
            target.positions || []
          ).map(
            (
              position
            ) => ({
              position,

              weight:
                1,
            })
          );


    const marketCount =
      weightedPositions.reduce(
        (
          sum,
          entry
        ) =>
          sum +
          Number(
            result.counts[
              entry.position - 1
            ] || 0
          ) *
          Number(
            entry.weight || 0
          ),
        0
      );


    if (
      target.complement
    ) {
      const runs =
        Number(
          simulationProgress.total
        ) || 0;


      return Math.max(
        0,
        runs -
          marketCount
      );
    }


    return marketCount;
  }


  function formatSeasonTargetPositions(
    target
  ) {
    const positions =
      target?.positions || [];

    if (
      positions.length ===
      0
    ) {
      return "";
    }

    if (
      positions.length ===
      1
    ) {
      return t(
        "help.simulationUI.seasonMarkets.positionOne",
        {
          position:
            positions[0],
        }
      );
    }

    const consecutive =
      positions.every(
        (
          position,
          index
        ) =>
          index === 0 ||
          position ===
            positions[
              index - 1
            ] +
              1
      );

    if (consecutive) {
      return t(
        "help.simulationUI.seasonMarkets.positionRange",
        {
          first:
            positions[0],

          last:
            positions[
              positions.length -
              1
            ],
        }
      );
    }

    return t(
      "help.simulationUI.seasonMarkets.positions",
      {
        positions:
          positions.join(
            ", "
          ),
      }
    );
  }


  function formatSimulationResult(
    count
  ) {
    const runs =
      Number(
        simulationProgress.total
      ) || 0;

    if (
      simulationResultMode ===
      "count"
    ) {
      return String(
        count
      );
    }

    const probability =
      runs > 0
        ? count / runs
        : 0;

    if (
      simulationResultMode ===
      "probability"
    ) {
      return (
        probability *
        100
      ).toLocaleString(
        numberLocale,
        {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }
      ) + " %";
    }

    if (
      probability <= 0
    ) {
      return "–";
    }

    return (
      1 / probability
    ).toLocaleString(
      numberLocale,
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    );
  }


  useEffect(() => {
    if (
      simulating ||
      simulationResults.length === 0
    ) {
      return;
    }

    const timer =
      window.setTimeout(
        () => {
          simulationResultsRef
            .current
            ?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
        },
        100
      );

    return () =>
      window.clearTimeout(
        timer
      );
  }, [
    simulating,
    simulationResults,
  ]);


  const matrixPercent =
    matrixProgress.total > 0
      ? (
          matrixProgress.current /
          matrixProgress.total
        ) * 100
      : 0;


  const simulationPercent =
    simulationProgress.total >
    0
      ? (
          simulationProgress
            .current /
          simulationProgress
            .total
        ) * 100
      : 0;


  return (
    <Dialog
      fullScreen
      open={Boolean(open)}
      onClose={
        handleClose
      }
      TransitionComponent={
        Transition
      }
    >
      <Dialog
        open={
          teamSettingsDialogOpen
        }
        onClose={() =>
          setTeamSettingsDialogOpen(
            false
          )
        }
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          {t(
            "help.simulationUI.teamSettings.title"
          )}
        </DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography>
              {t(
                "help.simulationUI.teamSettings.intro"
              )}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
            >
              {t(
                "help.simulationUI.teamSettings.description"
              )}
            </Typography>

            {!teamSettings.length ? (
              <Typography color="error">
                {t(
                  "help.simulationUI.teamSettings.missing"
                )}
              </Typography>
            ) : (
              <Box>
                {teamSettingsChanged && (
                  <Typography
                    variant="body2"
                    color="warning.main"
                    sx={{
                      mb: 1.5,
                      fontWeight: 600,
                    }}
                  >
                    {t(
                      "help.simulationUI.teamSettings.temporaryChanges"
                    )}
                  </Typography>
                )}

                <TeamStrengthEditor
                  user_id={
                    user?.id
                  }
                  season_id={
                    currentSeasonId
                  }
                  teams={
                    teamSettings
                  }
                  rows={
                    simulationTeamSettings
                  }
                  setRows={
                    setSimulationTeamSettings
                  }
                  apiRef={
                    teamSettingsApiRef
                  }
                  setHasChanges={
                    setTeamSettingsChanged
                  }
                  setCloseParent={() =>
                    setTeamSettingsDialogOpen(
                      false
                    )
                  }
                  seasonParamsReloadKey={
                    seasonParamsReloadKey
                  }
                  mode="full"
                />
              </Box>
            )}
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            px: {
              xs: 2,
              md: 3,
            },
            py: 2,
            gap: 1.5,
            alignItems: "stretch",
            flexWrap: "wrap",
          }}
        >
          <Button
            onClick={() =>
              setTeamSettingsDialogOpen(
                false
              )
            }
            disabled={
              teamSettingsSaving
            }
            sx={{
              alignSelf: "center",
            }}
          >
            {t(
              "help.simulationUI.teamSettings.cancel"
            )}
          </Button>

          <Box
            sx={{
              flex: "1 1 680px",
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md:
                  "repeat(2, minmax(0, 1fr))",
              },
              gap: 1.5,
            }}
          >
            <Tooltip
              arrow
              placement="top"
              title={t(
                "help.simulationUI.teamSettings.simulateTemporaryTooltip"
              )}
            >
              <Paper
                variant="outlined"
                role="button"
                tabIndex={0}
                onClick={() => {
                  if (
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                  ) {
                    return;
                  }

                  confirmTeamSettingsForSimulation();
                }}
                onKeyDown={(event) => {
                  if (
                    event.key !== "Enter" &&
                    event.key !== " "
                  ) {
                    return;
                  }

                  event.preventDefault();

                  if (
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                  ) {
                    return;
                  }

                  confirmTeamSettingsForSimulation();
                }}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  borderWidth: 2,
                  borderColor:
                    "rgba(196,150,55,0.55)",
                  background:
                    "linear-gradient(135deg, rgba(196,150,55,0.13), rgba(196,150,55,0.045))",
                  cursor:
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                      ? "default"
                      : "pointer",
                  opacity:
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                      ? 0.55
                      : 1,
                  transition:
                    "transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease",
                  "&:hover": {
                    transform:
                      !simulationTeamSettings.length ||
                      teamSettingsSaving
                        ? "none"
                        : "translateY(-2px)",
                    boxShadow:
                      !simulationTeamSettings.length ||
                      teamSettingsSaving
                        ? "none"
                        : "0 8px 22px rgba(70,35,50,0.13)",
                    borderColor:
                      !simulationTeamSettings.length ||
                      teamSettingsSaving
                        ? "rgba(196,150,55,0.55)"
                        : "primary.main",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    mb: 0.6,
                  }}
                >
                  {t(
                    "help.simulationUI.teamSettings.simulateTemporaryTitle"
                  )}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    lineHeight: 1.6,
                  }}
                >
                  {t(
                    "help.simulationUI.teamSettings.simulateTemporaryDescription"
                  )}
                </Typography>
              </Paper>
            </Tooltip>

            <Tooltip
              arrow
              placement="top"
              title={t(
                "help.simulationUI.teamSettings.saveAndSimulateTooltip"
              )}
            >
              <Paper
                variant="outlined"
                role="button"
                tabIndex={0}
                onClick={() => {
                  if (
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                  ) {
                    return;
                  }

                  saveTeamSettingsAndContinue();
                }}
                onKeyDown={(event) => {
                  if (
                    event.key !== "Enter" &&
                    event.key !== " "
                  ) {
                    return;
                  }

                  event.preventDefault();

                  if (
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                  ) {
                    return;
                  }

                  saveTeamSettingsAndContinue();
                }}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  borderWidth: 2,
                  borderColor:
                    "rgba(128,58,91,0.55)",
                  background:
                    "linear-gradient(135deg, rgba(128,58,91,0.14), rgba(128,58,91,0.045))",
                  cursor:
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                      ? "default"
                      : "pointer",
                  opacity:
                    !simulationTeamSettings.length ||
                    teamSettingsSaving
                      ? 0.55
                      : 1,
                  transition:
                    "transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease",
                  "&:hover": {
                    transform:
                      !simulationTeamSettings.length ||
                      teamSettingsSaving
                        ? "none"
                        : "translateY(-2px)",
                    boxShadow:
                      !simulationTeamSettings.length ||
                      teamSettingsSaving
                        ? "none"
                        : "0 8px 22px rgba(70,35,50,0.15)",
                    borderColor:
                      !simulationTeamSettings.length ||
                      teamSettingsSaving
                        ? "rgba(128,58,91,0.55)"
                        : "primary.main",
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 800,
                    mb: 0.6,
                  }}
                >
                  {teamSettingsSaving
                    ? t(
                        "help.simulationUI.teamSettings.saving"
                      )
                    : t(
                        "help.simulationUI.teamSettings.saveAndSimulateTitle"
                      )}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    lineHeight: 1.6,
                  }}
                >
                  {t(
                    "help.simulationUI.teamSettings.saveAndSimulateDescription"
                  )}
                </Typography>
              </Paper>
            </Tooltip>
          </Box>
        </DialogActions>
      </Dialog>


      <AppBar
        sx={{
          position:
            "relative",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={
              handleClose
            }
            aria-label={t(
              "help.closeHelp"
            )}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              ml: 2,
              flex: 1,
            }}
            variant="h6"
            component="div"
          >
            <Box
              sx={{
                display:
                  "flex",

                alignItems:
                  "center",

                gap: "0.5em",
              }}
            >
              {selectedLeague && (
                <LeagueDisplay
                  league={
                    selectedLeague
                  }
                  compact
                />
              )}

              <span>
                {t(
                  "help.simulationUI.title"
                )}
              </span>
            </Box>
          </Typography>
        </Toolbar>
      </AppBar>


      <Container
        maxWidth="xl"
        sx={{
          py: 2,
        }}
      >
        {matricesError && !rows.length && <Typography role="alert" color="error">{matricesError}</Typography>}
        {!selectedLeague ? (
          <Stack
            spacing={2}
            sx={{
              maxWidth: 900,
              mx: "auto",
              pt: 3,
            }}
          >
            <Paper
              variant="outlined"
              sx={{
                p: {
                  xs: 2,
                  md: 3,
                },

                borderRadius: 2,

                borderColor:
                  "rgba(128, 58, 91, 0.30)",

                background:
                  "linear-gradient(135deg, rgba(128,58,91,0.055), rgba(196,150,55,0.045))",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 800,
                  mb: 1,
                }}
              >
                {t(
                  "help.simulationUI.title"
                )}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  lineHeight: 1.7,
                  mb: 2.5,
                }}
              >
                {t(
                  "help.simulationUI.entry.description"
                )}
              </Typography>


              <Button
                component="a"
                href="help?target=simulation"
                target="_blank"
                rel="noreferrer"
                variant="text"
                size="small"
                sx={{
                  px: 0,
                  mb: 2.5,
                  alignSelf: "flex-start",
                  textTransform: "none",
                  fontWeight: 700,
                }}
              >
                {t(
                  "help.simulationUI.entry.readMore"
                )}
              </Button>


              <Typography
                variant="h6"
                sx={{
                  fontWeight: 750,
                  mb: 0.5,
                }}
              >
                {t(
                  "help.simulationUI.entry.chooseLeague"
                )}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mb: 1.25,
                }}
              >
                {t(
                  "help.simulationUI.entry.chooseLeagueDescription"
                )}
              </Typography>


              <TextField
                select
                fullWidth
                size="small"
                value=""
                onChange={
                  handleLeagueSelect
                }
                SelectProps={{
                  displayEmpty: true,
                }}
                sx={{
                  maxWidth: 520,
                }}
              >
                <MenuItem
                  value=""
                  disabled
                >
                  {t(
                    "help.simulationUI.entry.leaguePlaceholder"
                  )}
                </MenuItem>

                {leagues
                  .filter(
                    (item) =>
                      String(
                        item?.type || ""
                      ).toLowerCase() ===
                      "league"
                  )
                  .map(
                    (item) => (
                      <MenuItem
                        key={
                          item.id
                        }
                        value={
                          item.id
                        }
                      >
                        <LeagueDisplay
                          league={
                            item
                          }
                        />
                      </MenuItem>
                    )
                  )}
              </TextField>
            </Paper>
          </Stack>

        ) : !rows.length ? (
          <Box
            sx={{
              minHeight: 260,

              display:
                "flex",

              alignItems:
                "center",

              justifyContent:
                "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Stack
            spacing={2}
          >
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 800,
                  mb: 0.35,
                }}
              >
                {t(
                  "help.simulationUI.startingPoint.title"
                )}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mb: 1.5,
                }}
              >
                {t(
                  "help.simulationUI.startingPoint.description"
                )}
              </Typography>


              <Box
                sx={{
                  display: "grid",

                  gridTemplateColumns: {
                    xs: "1fr",

                    xl:
                      "repeat(2, minmax(0, 1fr))",
                  },

                  gap: 1.5,

                  alignItems:
                    "start",
                }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    overflow: "hidden",

                    borderRadius: 2,

                    borderColor:
                      "rgba(128, 58, 91, 0.30)",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.4,

                      bgcolor:
                        "rgba(128, 58, 91, 0.07)",

                      borderBottom:
                        "1px solid",

                      borderColor:
                        "divider",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 750,
                      }}
                    >
                      {t(
                        "help.simulationUI.startingPoint.standingsTitle"
                      )}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                    >
                      {t(
                        "help.simulationUI.startingPoint.standingsDescription"
                      )}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      p: 1,
                    }}
                  >
                    <LeagueTablePanel
                      rows={rows}
                      showTableMode
                      renderStats
                    />
                  </Box>
                </Paper>


                <Box>
                  {
                    renderTeamSettingsSummary()
                  }
                </Box>
              </Box>
            </Box>


            <Paper
              variant="outlined"
              sx={{
                p: {
                  xs: 1.5,
                  md: 2,
                },

                borderRadius: 2,

                borderColor:
                  "rgba(128, 58, 91, 0.30)",

                background:
                  "linear-gradient(135deg, rgba(128,58,91,0.055), rgba(196,150,55,0.045))",
              }}
            >
              <Stack
                direction={{
                  xs: "column",
                  md: "row",
                }}
                spacing={1.5}
                alignItems={{
                  xs: "stretch",
                  md: "center",
                }}
                justifyContent="space-between"
                sx={{
                  mb: 1.75,
                }}
              >
                <Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 800,
                    }}
                  >
                    {t(
                      "help.simulationUI.workspace.simulationTitle"
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 0.3,
                    }}
                  >
                    {t(
                      "help.simulationUI.workspace.simulationIntro"
                    )}
                  </Typography>
                </Box>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {rows.length}{" "}
                  {t(
                    "help.simulationUI.summary.teams"
                  )}
                  {" · "}
                  {openFixtures.length}{" "}
                  {t(
                    "help.simulationUI.summary.openFixtures"
                  )}
                </Typography>
              </Stack>


              <Typography
                variant="overline"
                sx={{
                  fontWeight: 800,
                  color: "primary.main",
                  letterSpacing: "0.06em",
                }}
              >
                {t(
                  "help.simulationUI.mode.chooseTitle"
                )}
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  mb: 1,
                }}
              >
                {t(
                  "help.simulationUI.workspace.modeIntro"
                )}
              </Typography>


              <Box
                sx={{
                  display: "grid",

                  gridTemplateColumns: {
                    xs: "1fr",
                    md:
                      "repeat(2, minmax(0, 1fr))",
                  },

                  gap: 1.25,
                }}
              >
                <Paper
                  variant="outlined"
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    if (
                      matricesLoading ||
                      simulating
                    ) {
                      return;
                    }

                    setSimulationMode(
                      "single"
                    );
                  }}
                  sx={{
                    p: 1.6,

                    borderRadius: 2,

                    borderWidth:
                      simulationMode ===
                      "single"
                        ? 2
                        : 1,

                    borderColor:
                      simulationMode ===
                      "single"
                        ? "primary.main"
                        : "divider",

                    bgcolor:
                      simulationMode ===
                      "single"
                        ? "rgba(196,150,55,0.11)"
                        : "background.paper",

                    cursor: "pointer",

                    transition:
                      "transform 140ms ease, box-shadow 140ms ease",

                    "&:hover": {
                      transform:
                        "translateY(-2px)",

                      boxShadow:
                        "0 7px 18px rgba(70,35,50,0.10)",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 800,
                    }}
                  >
                    {t(
                      "help.simulationUI.mode.singleTitle"
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 0.7,
                    }}
                  >
                    {t(
                      "help.simulationUI.mode.singleDescription"
                    )}
                  </Typography>

                </Paper>


                <Paper
                  variant="outlined"
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    if (
                      matricesLoading ||
                      simulating
                    ) {
                      return;
                    }

                    setSimulationMode(
                      "multiple"
                    );
                  }}
                  sx={{
                    p: 1.6,

                    borderRadius: 2,

                    borderWidth:
                      simulationMode ===
                      "multiple"
                        ? 2
                        : 1,

                    borderColor:
                      simulationMode ===
                      "multiple"
                        ? "primary.main"
                        : "divider",

                    bgcolor:
                      simulationMode ===
                      "multiple"
                        ? "rgba(196,150,55,0.11)"
                        : "background.paper",

                    cursor: "pointer",

                    transition:
                      "transform 140ms ease, box-shadow 140ms ease",

                    "&:hover": {
                      transform:
                        "translateY(-2px)",

                      boxShadow:
                        "0 7px 18px rgba(70,35,50,0.10)",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 800,
                    }}
                  >
                    {t(
                      "help.simulationUI.mode.multipleTitle"
                    )}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      mt: 0.7,
                    }}
                  >
                    {t(
                      "help.simulationUI.mode.multipleDescription"
                    )}
                  </Typography>


                  {simulationMode ===
                    "multiple" && (
                    <Box
                      sx={{
                        mt: 1.4,

                        pt: 1.2,

                        borderTop:
                          "1px solid",

                        borderColor:
                          "divider",
                      }}
                      onClick={(
                        event
                      ) =>
                        event.stopPropagation()
                      }
                    >
                      <TextField
                        size="small"

                        type="number"

                        label={t(
                          "help.simulationUI.mode.runs"
                        )}

                        value={
                          simulationRuns
                        }

                        onChange={(
                          event
                        ) =>
                          setSimulationRuns(
                            event
                              .target
                              .value
                          )
                        }

                        inputProps={{
                          min: 1,

                          max:
                            100000,

                          step:
                            100,
                        }}

                        disabled={
                          matricesLoading ||
                          simulating
                        }

                        sx={{
                          width: 200,
                        }}
                      />


                    </Box>
                  )}
                </Paper>
              </Box>


              <Divider
                sx={{
                  my: 2,
                }}
              />


              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}

                spacing={1}

                alignItems={{
                  xs: "stretch",
                  sm: "center",
                }}

                justifyContent=
                  "space-between"
              >
                <Box>
                  <Typography
                    variant="overline"
                    sx={{
                      fontWeight: 800,
                      color:
                        "primary.main",
                      letterSpacing:
                        "0.06em",
                    }}
                  >
                    {t(
                      "help.simulationUI.workspace.methodLabel"
                    )}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 750,
                    }}
                  >
                    {simulationMethod ===
                    "fast"
                      ? t(
                          "help.simulationUI.method.fast"
                        )

                      : simulationMethod ===
                        "direct"
                      ? t(
                          "help.simulationUI.method.direct"
                        )

                      : t(
                          "help.simulationUI.method.distribution"
                        )}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    {t(
                      "help.simulationUI.workspace.methodSecondary"
                    )}
                  </Typography>
                </Box>

                <Button
                  variant="outlined"
                  onClick={() =>
                    setMethodSelectionOpen(
                      (
                        value
                      ) =>
                        !value
                    )
                  }
                  disabled={
                    matricesLoading ||
                    simulating
                  }
                >
                  {methodSelectionOpen
                    ? t(
                        "help.simulationUI.workspace.hideMethods"
                      )

                    : t(
                        "help.simulationUI.workspace.changeMethod"
                      )}
                </Button>
              </Stack>


              {methodSelectionOpen && (
                <Box
                  sx={{
                    display: "grid",

                    gridTemplateColumns: {
                      xs: "1fr",

                      md:
                        "repeat(3, minmax(0, 1fr))",
                    },

                    gap: 1.25,

                    mt: 1.25,
                  }}
                >
                  {[
                    {
                      id: "fast",

                      title:
                        t(
                          "help.simulationUI.method.fast"
                        ),

                      description:
                        t(
                          "help.simulationUI.method.fastShort"
                        ),
                    },

                    {
                      id:
                        "direct",

                      title:
                        t(
                          "help.simulationUI.method.direct"
                        ),

                      description:
                        t(
                          "help.simulationUI.method.directShort"
                        ),
                    },

                    {
                      id:
                        "distribution",

                      title:
                        t(
                          "help.simulationUI.method.distribution"
                        ),

                      description:
                        t(
                          "help.simulationUI.method.distributionShort"
                        ),
                    },
                  ].map(
                    (
                      method
                    ) => {
                      const selected =
                        simulationMethod ===
                        method.id;

                      return (
                        <Paper
                          key={
                            method.id
                          }

                          variant="outlined"

                          role="button"

                          tabIndex={0}

                          onClick={() => {
                            if (
                              matricesLoading ||
                              simulating
                            ) {
                              return;
                            }

                            changeSimulationMethod(
                              method.id
                            );

                            setMethodSelectionOpen(
                              false
                            );
                          }}

                          sx={{
                            p: 1.5,

                            minHeight:
                              118,

                            borderRadius:
                              2,

                            borderWidth:
                              selected
                                ? 2
                                : 1,

                            borderColor:
                              selected
                                ? "primary.main"
                                : "divider",

                            bgcolor:
                              selected
                                ? "rgba(128,58,91,0.10)"
                                : "background.paper",

                            cursor:
                              "pointer",

                            transition:
                              "transform 140ms ease, box-shadow 140ms ease",

                            "&:hover": {
                              transform:
                                "translateY(-2px)",

                              boxShadow:
                                "0 7px 18px rgba(70,35,50,0.12)",
                            },
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight:
                                800,
                            }}
                          >
                            {
                              method.title
                            }
                          </Typography>

                          <Typography
                            variant="body2"
                            color=
                              "text.secondary"
                            sx={{
                              mt: 0.8,
                            }}
                          >
                            {
                              method.description
                            }
                          </Typography>
                        </Paper>
                      );
                    }
                  )}
                </Box>
              )}


              <Stack
                direction={{
                  xs: "column",

                  sm: "row",
                }}

                spacing={1.5}

                justifyContent=
                  "space-between"

                alignItems={{
                  xs: "stretch",

                  sm: "center",
                }}

                sx={{
                  mt: 2,

                  pt: 1.5,

                  borderTop:
                    "1px solid",

                  borderColor:
                    "divider",
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                >
                  {t(
                    "help.simulationUI.workspace.readyText",
                    {
                      count:
                        openFixtures.length,
                    }
                  )}
                </Typography>

                <Button
                  variant="contained"

                  size="large"

                  onClick={
                    runSimulation
                  }

                  disabled={
                    matricesLoading ||
                    simulating ||
                    !openFixtures.length
                  }

                  sx={{
                    minWidth:
                      230,

                    px: 3,

                    fontWeight:
                      800,
                  }}
                >
                  {matricesLoading
                    ? t(
                        "help.simulationUI.start.preparing"
                      )

                    : simulating
                    ? simulationMode ===
                      "multiple"
                      ? t(
                          "help.simulationUI.start.runningMultiple"
                        )

                      : t(
                          "help.simulationUI.start.runningSingle"
                        )

                    : simulationMode ===
                      "multiple"
                    ? t(
                        "help.simulationUI.start.multipleNew"
                      )

                    : t(
                        "help.simulationUI.start.singleNew"
                      )}
                </Button>
              </Stack>


              {matricesError && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{
                    mt: 1.5,
                  }}
                >
                  {matricesError}
                </Typography>
              )}


              {matricesLoading && (
                <Box
                  sx={{
                    mt: 1.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 0.75,
                    }}
                  >
                    {simulationMethod ===
                    "fast"
                      ? t(
                          "help.simulationUI.preparation.fastProgress",
                          {
                            current:
                              matrixProgress.current,

                            total:
                              matrixProgress.total,
                          }
                        )

                      : simulationMethod ===
                        "direct"
                      ? t(
                          "help.simulationUI.preparation.directProgress",
                          {
                            current:
                              matrixProgress.current,

                            total:
                              matrixProgress.total,
                          }
                        )

                      : t(
                          "help.simulationUI.preparation.progress",
                          {
                            current:
                              matrixProgress.current,

                            total:
                              matrixProgress.total,
                          }
                        )}
                  </Typography>

                  <LinearProgress
                    variant="determinate"

                    value={
                      matrixPercent
                    }
                  />
                </Box>
              )}


              {simulating && (
                <Box
                  sx={{
                    mt: 1.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 0.75,
                    }}
                  >
                    {t(
                      simulationMode ===
                        "multiple"
                        ? "help.simulationUI.progress.multiple"
                        : "help.simulationUI.progress.single",

                      {
                        current:
                          simulationProgress.current,

                        total:
                          simulationProgress.total,
                      }
                    )}
                  </Typography>

                  <LinearProgress
                    variant="determinate"

                    value={
                      simulationPercent
                    }
                  />
                </Box>
              )}
            </Paper>


            {simulationResults.length >
              0 && (
              <Paper
                ref={
                  simulationResultsRef
                }
                variant="outlined"
                sx={{
                  p: {
                    xs: 1.5,
                    md: 2,
                  },

                  borderRadius: 2,

                  borderColor:
                    "rgba(128, 58, 91, 0.30)",

                  overflowX:
                    "auto",
                }}
              >
                <Stack
                  spacing={1.5}
                  sx={{
                    mb: 2,
                  }}
                >
                  <Stack
                    direction={{
                      xs: "column",
                      md: "row",
                    }}
                    spacing={1.5}
                    alignItems={{
                      xs: "stretch",
                      md: "center",
                    }}
                    justifyContent=
                      "space-between"
                  >
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight:
                            800,
                        }}
                      >
                        {t(
                          "help.simulationUI.results.title"
                        )}
                      </Typography>

                      <Typography
                        variant="body2"
                        color=
                          "text.secondary"
                        sx={{
                          mt: 0.3,
                        }}
                      >
                        {t(
                          "help.simulationUI.results.runs",
                          {
                            count:
                              simulationProgress.total,
                          }
                        )}
                      </Typography>
                    </Box>


                    <Stack
                      direction="row"
                      spacing={0.5}
                      sx={{
                        flexWrap:
                          "wrap",
                        gap: 0.5,
                      }}
                    >
                      <Button
                        size="small"
                        variant={
                          simulationResultMode ===
                          "odds"
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() =>
                          setSimulationResultMode(
                            "odds"
                          )
                        }
                      >
                        {t(
                          "help.simulationUI.resultMode.fairOdds"
                        )}
                      </Button>

                      <Button
                        size="small"
                        variant={
                          simulationResultMode ===
                          "probability"
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() =>
                          setSimulationResultMode(
                            "probability"
                          )
                        }
                      >
                        {t(
                          "help.simulationUI.resultMode.probability"
                        )}
                      </Button>

                      <Button
                        size="small"
                        variant={
                          simulationResultMode ===
                          "count"
                            ? "contained"
                            : "outlined"
                        }
                        onClick={() =>
                          setSimulationResultMode(
                            "count"
                          )
                        }
                      >
                        {t(
                          "help.simulationUI.resultMode.count"
                        )}
                      </Button>
                    </Stack>
                  </Stack>


                  <Divider />


                  <Box>
                    <Typography
                      variant="overline"
                      sx={{
                        fontWeight:
                          800,

                        color:
                          "primary.main",

                        letterSpacing:
                          "0.06em",
                      }}
                    >
                      {t(
                        "help.simulationUI.seasonMarkets.chooseMarket"
                      )}
                    </Typography>

                    <Box
                      sx={{
                        display:
                          "flex",

                        flexWrap:
                          "wrap",

                        gap:
                          0.75,

                        mt:
                          0.5,
                      }}
                    >
                      {getSeasonTargets().map(
                        (
                          target
                        ) => (
                          <Button
                            key={
                              target.id
                            }

                            size="small"

                            variant={
                              getSelectedSeasonTarget()
                                ?.id ===
                              target.id
                                ? "contained"
                                : "outlined"
                            }

                            onClick={() =>
                              setSimulationAnalysis(
                                target.id
                              )
                            }

                            sx={{
                              textTransform:
                                "none",
                            }}
                          >
                            {getSeasonTargetLabel(
                              target
                            )}
                          </Button>
                        )
                      )}
                    </Box>
                  </Box>


                  {getSelectedSeasonTarget() && (
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight:
                            800,
                        }}
                      >
                        {getSeasonTargetLabel(
                          getSelectedSeasonTarget()
                        )}
                      </Typography>

                      <Typography
                        variant="body2"
                        color=
                          "text.secondary"
                      >
                        {formatSeasonTargetPositions(
                          getSelectedSeasonTarget()
                        )}
                      </Typography>
                    </Box>
                  )}


                  {!seasonBaseRecord && (
                    <Typography
                      variant="body2"
                      color=
                        "warning.main"
                    >
                      {t(
                        "help.simulationUI.seasonMarkets.rulesMissing"
                      )}
                    </Typography>
                  )}
                </Stack>


                {getSelectedSeasonTarget() && (
                  <table
                    style={{
                      width:
                        "100%",

                      borderCollapse:
                        "collapse",

                      whiteSpace:
                        "nowrap",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            textAlign:
                              "left",

                            padding:
                              "8px 10px",
                          }}
                        >
                          {t(
                            "help.simulationUI.columns.team"
                          )}
                        </th>

                        <th
                          style={{
                            textAlign:
                              "right",

                            padding:
                              "8px 10px",
                          }}
                        >
                          {t(
                            "help.simulationUI.seasonMarkets.reached"
                          )}
                        </th>

                        <th
                          style={{
                            textAlign:
                              "right",

                            padding:
                              "8px 10px",
                          }}
                        >
                          {t(
                            "help.simulationUI.seasonMarkets.notReached"
                          )}
                        </th>
                      </tr>
                    </thead>


                    <tbody>
                      {simulationResults
                        .slice()
                        .sort(
                          (
                            first,
                            second
                          ) =>
                            getSeasonTargetCount(
                              second,
                              getSelectedSeasonTarget()
                            ) -
                            getSeasonTargetCount(
                              first,
                              getSelectedSeasonTarget()
                            )
                        )
                        .map(
                          (
                            result
                          ) => {
                            const reachedCount =
                              getSeasonTargetCount(
                                result,
                                getSelectedSeasonTarget()
                              );

                            const runs =
                              Number(
                                simulationProgress.total
                              ) || 0;

                            const notReachedCount =
                              Math.max(
                                0,
                                runs -
                                  reachedCount
                              );


                            return (
                              <tr
                                key={
                                  result.team_id
                                }
                              >
                                <td
                                  style={{
                                    padding:
                                      "8px 10px",

                                    borderTop:
                                      "1px solid #ddd",
                                  }}
                                >
                                  <span
                                    style={{
                                      display:
                                        "inline-flex",

                                      alignItems:
                                        "center",

                                      gap:
                                        "0.5em",
                                    }}
                                  >
                                    {result.logo_path && (
                                      <img
                                        src={
                                          result.logo_path
                                        }
                                        alt=""
                                        style={{
                                          height:
                                            "20px",
                                        }}
                                      />
                                    )}

                                    {
                                      result.team_name
                                    }
                                  </span>
                                </td>

                                <td
                                  style={{
                                    textAlign:
                                      "right",

                                    padding:
                                      "8px 10px",

                                    borderTop:
                                      "1px solid #ddd",

                                    fontWeight:
                                      simulationResultMode ===
                                      "odds"
                                        ? 800
                                        : 600,
                                  }}
                                >
                                  {formatSimulationResult(
                                    reachedCount
                                  )}
                                </td>

                                <td
                                  style={{
                                    textAlign:
                                      "right",

                                    padding:
                                      "8px 10px",

                                    borderTop:
                                      "1px solid #ddd",
                                  }}
                                >
                                  {formatSimulationResult(
                                    notReachedCount
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                )}
              </Paper>
            )}



          </Stack>
        )}
      <SimulatedScorers data={scorerResults} />
      </Container>
    </Dialog>
  );
}
